import { Modal } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import "./modals.scss";
import { translateToReactSelect } from "../../../utils/helperFunction";
import BankAccountList from "./BankAccountList";
import Tabs from "../../tab/Tabs";
import BaseInfoData from "./BaseInfoData";
import CustomButton from "../../kits/button/CustomButton";
import { EditIcon, CloseIcon } from "../../kits/Icons";
import ToastCustomize from "../../kits/ToastCustomize";
import { CustomTooltip } from "../../kits/tooltip/CustomTooltip";
import { SeparatorInput } from "../../kits/Inputs/Inputs";
import WithAuthentication from "../../../Authentication/AuthenticationContext";
import { showSwalSuccess, showSwalError } from "../../../utils/swal.js";
import useAxios from "../../../services/useAxios.tsx";

export default function SendMassage({ show, setShow, selected }) {
  const [SendMg, setSendMg] = useState({
    msgtxt: "",
    needsms: false,
  });

  const auth = useContext(WithAuthentication);
  const { execute: Insert_Message } = useAxios("api/Insert_Message");

  const SendMessage = (AppendObj, people, setSendMg) => {
    if (people[0][1] == "" && AppendObj.needsms == 1) {
      showSwalError("\n کاربر مورد نظر ایمیلی ندارد");
    } else {
      const currentDate = new Date();
      const timestamp = currentDate.getTime();
      let form = new FormData();
      form.append("sender_id", `${auth.userInfo.id}`);
      form.append("type", AppendObj.needsms ? 1 : AppendObj.needemail ? 2 : 0);
      form.append("reciver_id", `${people[0][0]}`);
      form.append("text", `${AppendObj.msgtxt}`);
      form.append("mtm", `${timestamp}`);
      form.append("automate", 0);
      form.append("needsms", `${AppendObj.needsms ? 1 : 0}`);
      Insert_Message(form)
        .then((data) => {
          if (data.status) {
            showSwalSuccess("پیام ارسال شد");
            setSendMg({
              ...AppendObj,
              ["msgtxt"]: "",
              ["needsms"]: false,
            });
            setShow(false);
          } else {
            showSwalError("\n مشکلی در ارسال پیام پیش آمده است ");
            setShow(false);
            return;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <>
      <div>
        <Modal
          show={show}
          onHide={() => setShow(false)}
          size="lg"
          fullscreen="lg-down"
          className="p-0"
        >
          <Modal.Header>
            ارسال پیام
            <div
              className="cursor-pointer"
              onClick={() => {
                setShow(false);
              }}
            >
              <CloseIcon />
            </div>
          </Modal.Header>
          <Modal.Body className="add-edit-customer-modal">
            <div className=" ">
              <label htmlFor="send-message-input1" className="mb-2">
                پیام:
              </label>
              <textarea
                required
                id="send-message-input1"
                className="form-control ms-2 mb-2 "
                value={SendMg.msgtxt}
                onChange={(e) =>
                  setSendMg({ ...SendMg, ["msgtxt"]: e.target.value })
                }
              ></textarea>

              <br />
              <input
                type="checkbox"
                className="mx-2 form-check-input"
                id="SMS-Check"
                value={SendMg.needsms ? true : false}
                onChange={(e) =>
                  setSendMg({
                    ...SendMg,
                    ["needsms"]: e.target.checked ? 1 : 0,
                  })
                }
              />
              <label htmlFor="SMS-Check" className="m-1">
                ارسال پیامک
              </label>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => setShow(false)}
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              انصراف
            </button>
            <button
              type="button"
              onClick={() => {
                console.log(selected);
                SendMessage(
                  SendMg,
                  [[selected.id, selected.mobile]],
                  setSendMg
                );
              }}
              className="btn btn-primary"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              ارسال
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}
